import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Button from '~/components/common/Button';
import ProductsEntries from './ProductsEntries';

import { api_getProductTabs } from '~/backend/api_calls';
import { viewItemListGTAG4Event } from '~/common/gtag4';
import { attachIndexesToProducts } from '~/common/helper';

// Demo import

const RecommendedProducts = () => {
	const { t } = useTranslation();
	const [productTab, setProductTab] = useState(null);
	const [activeTabIndex, setActiveTabIndex] = useState(0);
	const [products, setProducts] = useState([]);

	const [hasSentEvent, setHasSentEvent] = useState(false);

	useEffect(() => {
		if (!hasSentEvent && products.length > 0) {
			viewItemListGTAG4Event(attachIndexesToProducts(products), 'Recommended Products');
			setHasSentEvent(true);
		}
	}, [hasSentEvent, products]);

	useEffect(() => {
		api_getProductTabs()
			.then(json => {
				setProductTab(json.items[0]);
			})
			.catch(error => {
				console.log(error);
			});
	}, []);

	return (
		<div className="recommended-products">
			<div className="content-wrapper">
				<div className="recommended-products-header">
					<h2>{productTab?.tl}</h2>
					<div className="tab-buttons">
						{productTab?.product_tab_entries.map((tab, index) => (
							<button key={index} className={activeTabIndex === index ? 'active' : ''} onClick={() => setActiveTabIndex(index)}>
								{tab.nm}
							</button>
						))}
					</div>
				</div>
				<div className="recommended-products-container">
					{productTab?.product_tab_entries[activeTabIndex] && (
						<ProductsEntries
							products={products}
							setProducts={setProducts}
							productsIds={productTab.product_tab_entries[activeTabIndex].product_ids}
						/>
					)}
				</div>
				{productTab?.nu && (
					<div className="recommended-products-footer">
						{/* <Link to={productTab.nu}> */}
						<Link
							to={
								activeTabIndex == 0
									? '/categories/andrika-papoutsia?q=status%3A%CE%9D%CE%95%CE%91+%CE%A3%CE%A5%CE%9B%CE%9B%CE%9F%CE%93%CE%97'
									: activeTabIndex == 1
										? '/categories/andrika-rouxa?q=status%3AΝΕΑ+ΣΥΛΛΟΓΗ'
										: activeTabIndex == 2
											? '/categories/andrika-axesouar?q=status%3AΝΕΑ+ΣΥΛΛΟΓΗ'
											: '#'
							}>
							<Button color="secondary" outline={true}>
								<h3>{t('see_more')}</h3>
							</Button>
						</Link>
					</div>
				)}
			</div>
		</div>
	);
};

export default RecommendedProducts;
